module.exports = "<div class=\"number-data\">{{number || '0'}}</div>\n<div class=\"title-data\">{{titleBox}}</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/about/box-data/box-data.component.html
// module id = 1717
// module chunks = 0